// import store from "App/Redux/store";
import { getLocalIP, getToken } from "App/utils/cookies"
import axios from "axios"
import { TOKEN_TELEKONSUL } from "./variable"
import { generateTokenEmrSetting } from "App/utils/crypto"
import { buildApiBaseUrl } from "App/utils/apiBaseUrl"
export const APP_DEBUG = true

/**
 * SIMRS URL SERVICE
 * env tidak bisa membaca boolean, maka kita buat secara manual
 */

const USE_PUBLIC = process.env.REACT_APP_USE_PUBLIC === "true" ? true : false
const SSL = process.env.REACT_APP_SSL === "true" ? true : false

const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL

const PRIVATE_URL = process.env.REACT_APP_PRIVATE_URL

export const BASE_URL = USE_PUBLIC ? PUBLIC_URL : PRIVATE_URL

/**
 * GO URL
 */

const PUBLIC_GO_URL = process.env.REACT_APP_PUBLIC_GO_URL
const PRIVATE_GO_URL = process.env.REACT_APP_PRIVATE_GO_URL
const _BASE_URL_GO = USE_PUBLIC ? PUBLIC_GO_URL : PRIVATE_GO_URL

/**
 * EMR SERVICE URL
 */

export const BASE_URL_EMR = USE_PUBLIC
  ? `${process.env.REACT_APP_EMR_PUBLIC_URL}/api`
  : `${process.env.REACT_APP_EMR_PRIVATE_URL}/api`

/**
 * WMS BPJS SERVICE URL
 */

export const BASE_URL_WMS_BPJS = USE_PUBLIC
  ? `${process.env.REACT_APP_EMR_WMS_BPJS_PUBLIC_URL}/api`
  : `${process.env.REACT_APP_EMR_WMS_BPJS_PRIVATE_URL}/api`

/**
 * VCLAIM SERVICE URL
 */

export const BASE_URL_VCLAIM = USE_PUBLIC
  ? `${process.env.REACT_APP_EMR_VCLAIM_PUBLIC_URL}/api`
  : `${process.env.REACT_APP_EMR_VCLAIM_PRIVATE_URL}/api`

export const SESSION_ID_EMR =
  "$2a$10$KJYdJ2ERpcungdVncDjtDO7pNHXpDmukTvDuk.bzYOCODUvApkFly"
export const V1 = "v1"

// export const BASE_URL_1 = USE_PUBLIC
//   ? `${PUBLIC_URL}:${process.env.REACT_APP_PORT_MASTER}`
//   : `${PRIVATE_URL}:${process.env.REACT_APP_PORT_MASTER}`

export const BASE_URL_1 = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_MASTER, process.env.REACT_APP_PORT_MASTER)
  : buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_MASTER)

// export const BASE_URL_2 = USE_PUBLIC
//   ? `${PUBLIC_URL}:${process.env.REACT_APP_PORT_REGISTRASI}`
//   : `${PRIVATE_URL}:${process.env.REACT_APP_PORT_REGISTRASI}`

export const BASE_URL_2 = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_REGISTRASI, process.env.REACT_APP_PORT_REGISTRASI)
  : buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_REGISTRASI)

// export const BASE_URL_3 = USE_PUBLIC
//   ? `${PUBLIC_URL}:${process.env.REACT_APP_PORT_BILLING}`
//   : `${PRIVATE_URL}:${process.env.REACT_APP_PORT_BILLING}`

export const BASE_URL_3 = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_BILLING, process.env.REACT_APP_PORT_BILLING)
  : buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_BILLING)

// export const BASE_URL_4 = USE_PUBLIC
//   ? `${PUBLIC_URL}:${process.env.REACT_APP_PORT_WAREHOUSE}`
//   : `${PRIVATE_URL}:${process.env.REACT_APP_PORT_WAREHOUSE}`

export const BASE_URL_4 = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_WAREHOUSE, process.env.REACT_APP_PORT_WAREHOUSE)
  : buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_WAREHOUSE)

// export const BASE_URL_5 = USE_PUBLIC
//   ? `${PUBLIC_URL}:${process.env.REACT_APP_PORT_AKUNTANSI}`
//   : `${PRIVATE_URL}:${process.env.REACT_APP_PORT_AKUNTANSI}`

export const BASE_URL_5 = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_AKUNTANSI, process.env.REACT_APP_PORT_AKUNTANSI)
  : buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_AKUNTANSI)

// export const BASE_URL_6 = USE_PUBLIC
//   ? `${PUBLIC_URL}:${process.env.REACT_APP_PORT_EMR_REPORT}`
//   : `${PRIVATE_URL}:${process.env.REACT_APP_PORT_EMR_REPORT}`

export const BASE_URL_6 = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_EMR_REPORT, process.env.REACT_APP_PORT_EMR_REPORT)
  : buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_EMR_REPORT)

// export const BASE_URL_GO = USE_PUBLIC
//   ? `${PUBLIC_GO_URL}:${process.env.REACT_APP_PORT_GO}`
//   : `${PRIVATE_GO_URL}:${process.env.REACT_APP_PORT_GO}`

export const BASE_URL_GO = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_GO, process.env.REACT_APP_PORT_GO)
  : buildApiBaseUrl(_BASE_URL_GO, process.env.REACT_APP_PORT_GO)

// export const BASE_URL_SOCKET = USE_PUBLIC
//   ? `${PUBLIC_URL}:${process.env.REACT_APP_PORT_SOCKET}`
//   : `${PRIVATE_URL}:${process.env.REACT_APP_PORT_SOCKET}`

const rawUrlSocket = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_SOCKET, process.env.REACT_APP_PORT_SOCKET)
  : buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_SOCKET)

// io() memperlakukan segmen path pada URL sebagai NAMESPACE, bukan path Engine.IO.
// Untuk gateway ber-path (mis. https://host/be-simrs-websocket/) origin & path harus
// dipisah: origin -> argumen pertama io(), path -> opsi `path`. Kalau bukan URL valid
// (mis. konfigurasi lama tanpa scheme) biarkan apa adanya + path default.
const parsedUrlSocket = (() => {
  try {
    return new URL(rawUrlSocket)
  } catch {
    return null
  }
})()

export const BASE_URL_SOCKET = parsedUrlSocket ? parsedUrlSocket.origin : rawUrlSocket

export const BASE_URL_SOCKET_PATH =
  parsedUrlSocket && parsedUrlSocket.pathname !== "/"
    ? `${parsedUrlSocket.pathname.replace(/\/+$/, "")}/socket.io/`
    : "/socket.io/"

// export const BASE_URL_BPJS_VCLAIM = USE_PUBLIC
//   ? `${PUBLIC_URL}:${process.env.REACT_APP_PORT_VCLAIM}`
//   : `${PRIVATE_URL}:${process.env.REACT_APP_PORT_VCLAIM}`

export const BASE_URL_BPJS_VCLAIM = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_BPJS_VCLAIM, process.env.REACT_APP_PORT_VCLAIM)
  : buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_VCLAIM)

// export const BASE_URL_BPJS_APOTEK = USE_PUBLIC
//   ? `${PUBLIC_URL}:${process.env.REACT_APP_PORT_APOTEK}`
//   : `${PRIVATE_URL}:${process.env.REACT_APP_PORT_APOTEK}`

export const BASE_URL_BPJS_APOTEK = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_BPJS_APOTEK, process.env.REACT_APP_PORT_BPJS_APOTEK)
  : buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_BPJS_APOTEK)

// export const BASE_URL_APPLICARES = USE_PUBLIC
//   ? `${PUBLIC_URL}:${process.env.REACT_APP_PORT_APPLICARES}`
//   : `${PRIVATE_URL}:${process.env.REACT_APP_PORT_APPLICARES}`

export const BASE_URL_APPLICARES = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_APPLICARES, process.env.REACT_APP_PORT_APPLICARES)
  : buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_APPLICARES)

// export const BASE_URL_WS_BPJS = USE_PUBLIC
//   ? `${PUBLIC_URL}:${process.env.REACT_APP_PORT_WS_BPJS}`
//   : `${PRIVATE_URL}:${process.env.REACT_APP_PORT_WS_BPJS}`

export const BASE_URL_WS_BPJS = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_WS_BPJS, process.env.REACT_APP_PORT_WS_BPJS)
  : buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_WS_BPJS)

// export const BASE_URL_EMR_V2_AKSES = USE_PUBLIC
//   ? `${PUBLIC_URL}:${process.env.REACT_APP_PORT_EMR_V2_AKSES}`
//   : `${PRIVATE_URL}:${process.env.REACT_APP_PORT_EMR_V2_AKSES}`

export const BASE_URL_EMR_V2_AKSES = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_EMR_V2_AKSES, process.env.REACT_APP_PORT_EMR_V2_AKSES)
  : buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_EMR_V2_AKSES)

// export const BASE_URL_SATU_SEHAT = USE_PUBLIC
//   ? `${PUBLIC_URL}:${process.env.REACT_APP_PORT_SATU_SEHAT}`
//   : `${PRIVATE_URL}:${process.env.REACT_APP_PORT_SATU_SEHAT}`

export const BASE_URL_SATU_SEHAT = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_SATU_SEHAT, process.env.REACT_APP_PORT_SATU_SEHAT)
  : buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_SATU_SEHAT)

export const BASE_URL_7 = USE_PUBLIC
  ? buildApiBaseUrl(PUBLIC_URL, "7003")
  : buildApiBaseUrl(PRIVATE_URL, "7003")

export const BASE_URL_LOCAL = buildApiBaseUrl(
  "http://10.10.100.57",
  process.env.REACT_APP_PORT_REGISTRASI,
)

// export const BASE_URL_EMR_MASTER = USE_PUBLIC
//   ? `${PUBLIC_URL}:${process.env.REACT_APP_PORT_EMR_V2_MASTER}`
//   : `${PRIVATE_URL}:${process.env.REACT_APP_PORT_EMR_V2_MASTER}`

export const BASE_URL_EMR_MASTER = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_EMR_V2_MASTER, process.env.REACT_APP_PORT_EMR_V2_MASTER)
  : buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_EMR_V2_MASTER)

// export const BASE_URL_EMR_V3_REGISTRASI = USE_PUBLIC
//   ? `${PUBLIC_URL}:${process.env.REACT_APP_PORT_EMR_V3_REGISTRASI}/v3`
//   : `${PRIVATE_URL}:${process.env.REACT_APP_PORT_EMR_V3_REGISTRASI}/v3`

export const BASE_URL_EMR_V3_REGISTRASI = SSL
  ? `${buildApiBaseUrl(process.env.REACT_APP_BASE_URL_EMR_V3_REGISTRASI, process.env.REACT_APP_PORT_EMR_V3_REGISTRASI)}/v3`
  : `${buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_EMR_V3_REGISTRASI)}/v3`

export const BASE_URL_HRIS = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_HRIS, process.env.REACT_APP_PORT_HRIS)
  : buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_HRIS)

// export const BASE_URL_EMR_PENUNJANG = USE_PUBLIC
//   ? `${PUBLIC_URL}:${process.env.REACT_APP_PORT_EMR_PENUNJANG}`
//   : `${PRIVATE_URL}:${process.env.REACT_APP_PORT_EMR_PENUNJANG}`

export const BASE_URL_EMR_PENUNJANG = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_EMR_PENUNJANG, process.env.REACT_APP_PORT_EMR_PENUNJANG)
  : buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_EMR_PENUNJANG)

export const BASE_URL_SATU_SEHAT_V2 = SSL
  ? buildApiBaseUrl(process.env.REACT_APP_BASE_URL_SATU_SEHAT_V2, process.env.REACT_APP_PORT_SATU_SEHAT_V2)
  : buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT_SATU_SEHAT_V2)

export const BASE_URL_TELEKONSUL = "http://192.168.0.88:5044"

export const TOKEN = getToken()

const USER_CODE = getLocalIP()

export const instance1 = axios.create({
  baseURL: BASE_URL_1,
  headers: {
    token: TOKEN,
    usercode: USER_CODE,
    withCredentials: true,
  },
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
})

instance1.interceptors.request.use(
  (request) => {
    const token = getToken()
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instance2 = axios.create({
  baseURL: BASE_URL_2,
  headers: {
    token: TOKEN,
    usercode: USER_CODE,
    withCredentials: true,
  },
})

instance2.interceptors.request.use(
  (request) => {
    const token = getToken()
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instance3 = axios.create({
  baseURL: BASE_URL_3,
  headers: {
    token: TOKEN,
    usercode: USER_CODE,
    withCredentials: true,
  },
})

instance3.interceptors.request.use(
  (request) => {
    const token = getToken()
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instance4 = axios.create({
  baseURL: BASE_URL_4,
  headers: {
    token: TOKEN,
    usercode: USER_CODE,
    withCredentials: true,
  },
  // timeout: 10000000,
})

instance4.interceptors.request.use(
  (request) => {
    const token = getToken()
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instance5 = axios.create({
  baseURL: BASE_URL_5,
  headers: {
    token: TOKEN,
    withCredentials: true,
    usercode: USER_CODE,
  },
  // timeout: 10000,
})

instance5.interceptors.request.use(
  (request) => {
    const token = getToken()
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instance6 = axios.create({
  baseURL: BASE_URL_6,
  headers: {
    token: TOKEN,
    withCredentials: true,
    usercode: USER_CODE,
  },
})

instance6.interceptors.request.use(
  (request) => {
    const token = getToken()
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instanceGo = axios.create({
  baseURL: BASE_URL_GO,
  headers: {
    token: TOKEN,
    usercode: USER_CODE,
    withCredentials: true,
  },
  // timeout: 10000,
})

instanceGo.interceptors.request.use(
  (request) => {
    const token = getToken()
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instanceWsBPJS = axios.create({
  baseURL: BASE_URL_WS_BPJS,
  headers: {
    token: TOKEN,
    usercode: USER_CODE,
    withCredentials: true,
  },
  // timeout: 10000,
})

instanceWsBPJS.interceptors.request.use(
  (request) => {
    const token = getToken()
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instance7 = axios.create({
  baseURL: BASE_URL_7,
  headers: {
    token: TOKEN,
    usercode: USER_CODE,
    withCredentials: true,
  },
  // timeout: 10000,
})

instance7.interceptors.request.use(
  (request) => {
    const token = getToken()
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instanceVclaim = axios.create({
  baseURL: BASE_URL_BPJS_VCLAIM,
  headers: {
    token: TOKEN,
    usercode: USER_CODE,
    withCredentials: true,
  },
})

instanceVclaim.interceptors.request.use(
  (request) => {
    const token = getToken()
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instanceApotek = axios.create({
  baseURL: BASE_URL_BPJS_APOTEK,
  headers: {
    token: TOKEN,
    usercode: USER_CODE,
    withCredentials: true,
  },
})

instanceApotek.interceptors.request.use(
  (request) => {
    const token = getToken()
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instanceApplicares = axios.create({
  baseURL: BASE_URL_APPLICARES,
  headers: {
    token: TOKEN,
    usercode: USER_CODE,
    withCredentials: true,
  },
  // timeout: 10000,
})

instanceApplicares.interceptors.request.use(
  (request) => {
    const token = getToken()
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const goEMR = axios.create({
  baseURL: BASE_URL_EMR,
})

export const goWmsBpjs = axios.create({
  baseURL: BASE_URL_WMS_BPJS,
})

export const goUrl = axios.create({
  baseURL: BASE_URL_GO,
})

export const instanceTelekonsul = axios.create({
  baseURL: BASE_URL_TELEKONSUL,
  headers: {
    token: TOKEN_TELEKONSUL,
    withCredentials: true,
  },
})

export const instanceEmrV2Akses = axios.create({
  baseURL: BASE_URL_EMR_V2_AKSES,
  headers: {
    token: TOKEN,
    usercode: USER_CODE,
    withCredentials: true,
  },
  // timeout: 10000,
})

instanceEmrV2Akses.interceptors.request.use(
  (request) => {
    const token = getToken()
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instanceSatuSehat = axios.create({
  baseURL: BASE_URL_SATU_SEHAT,
  headers: {
    token: TOKEN,
    usercode: USER_CODE,
    withCredentials: true,
  },
})

instanceSatuSehat.interceptors.request.use(
  (request) => {
    const token = getToken()
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instancePublicMasterEMR = axios.create({
  baseURL: BASE_URL_EMR_MASTER,
  headers: {
    token: generateTokenEmrSetting(["favicon", "name"]),
    withCredentials: true,
    usercode: USER_CODE,
  },
  // timeout: 10000,
})

instancePublicMasterEMR.interceptors.request.use(
  (request) => {
    const token = generateTokenEmrSetting(["favicon", "name"])
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instancePublicMasterEMRV2 = axios.create({
  baseURL: BASE_URL_EMR_MASTER,
  headers: {
    token: TOKEN,
    withCredentials: true,
    usercode: USER_CODE,
  },
})

instancePublicMasterEMRV2.interceptors.request.use(
  (request) => {
    const token = TOKEN
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instanceRegistrasiEMRV3 = axios.create({
  baseURL: BASE_URL_EMR_V3_REGISTRASI,
  headers: {
    token: TOKEN,
    withCredentials: true,
    usercode: USER_CODE,
  },
})

instanceRegistrasiEMRV3.interceptors.request.use(
  (request) => {
    const token = TOKEN
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instanceHRIS = axios.create({
  baseURL: BASE_URL_HRIS,
  headers: {
    token: TOKEN,
    withCredentials: true,
    usercode: USER_CODE,
  },
})
instanceHRIS.interceptors.request.use(
  (request) => {
    const token = TOKEN
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instancePenunjang = axios.create({
  baseURL: BASE_URL_EMR_PENUNJANG,
  headers: {
    token: TOKEN,
    withCredentials: true,
    usercode: USER_CODE,
  },
})

instancePenunjang.interceptors.request.use(
  (request) => {
    const token = TOKEN
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const instanceSatuSehatV2 = axios.create({
  baseURL: BASE_URL_SATU_SEHAT_V2,
  headers: {
    token: TOKEN,
    usercode: USER_CODE,
    withCredentials: true,
  },
})

instanceSatuSehatV2.interceptors.request.use(
  (request) => {
    const token = getToken()
    request.headers["token"] = token
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)
